(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-dart/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-dart/assets/javascripts/status.js'); "use strict";

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_dart = svs.themes.sport_dart || {};
  var logger = new svs.core.log.Logger('svs.themes.sport_dart');

  svs.themes.sport_dart.matchNotice = function (match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }

    var matchStatus;

    switch (match.status) {
      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      case 29:
      case 116:
      case 117:
        matchStatus = 'Walkover';
        break;

      case 30:
      case 118:
      case 119:
        matchStatus = 'Deltagare bröt';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_dart.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([13, 14, 115], status);
  };

  svs.themes.sport_dart.isFinished = function (status) {
    return status === 31;
  };

  svs.themes.sport_dart.isEnded = function (status) {
    return !!(_.contains([25, 26, 28, 29, 30, 31], status) || status > 115 && status < 122);
  }; 


  svs.themes.sport_dart.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -4) && !svs.themes.sport_dart.isEnded(params.status);
  };

  svs.themes.sport_dart.hasStarted = function (status) {
    return status > 0 && status !== 24;
  };


  svs.themes.sport_dart.isFullTimeOrPassed = function (status, options) {
    options = _.extend({
      includeFullTime: true,
      includePauses: true,
      includeFinished: true
    }, options);
    var statusesForOvertime = [];

    if (options.includeFullTime) {
      statusesForOvertime.push(31);
    }

    if (options.includePauses) {
      statusesForOvertime.push(14);
    }

    return _.contains(statusesForOvertime, status);
  };


  svs.themes.sport_dart.getStatusText = function (options) {
    var text = '';
    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });
    var status = options.statusId;

    if (svs.themes.sport_dart.isLive(status)) {
      if (_.contains([115, 13], status)) {
        text = 'LIVE';
      } else if (status === 14) {
        text = 'PAUS';
      }
    } else if (svs.themes.sport_dart.isEnded(status)) {
      if (status === 25) {
        text = 'INST';
      } else if (status === 28) {
        text = 'UPPH';
      } else if (status === 26) {
        text = 'AVBR';
      } else if (_.contains([29, 30, 116, 117, 118, 119, 120, 121], status)) {
        text = 'SLUT';
      } else {
        text = 'SLUT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };
})(svs);
 })(window);